export class EventBackgroundOutcome {
  public citations?: string[];
  public description: string;
}
